export const getStoredTheme = (key: string): 'light' | 'dark' | 'system' => {
  const themeKey = localStorage.getItem(key);
  if (themeKey && (themeKey === 'light' || themeKey === 'dark' || themeKey === 'system')) {
    return themeKey;
  }
  return 'light';
};
